import React from 'react';
import { IconProps } from '.';

const SvgLayout = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        fillRule='evenodd'
        d='M2.25 2.25h19.5v19.5H2.25V2.25Zm1.5 1.5v5.534h16.5V3.75H3.75Zm16.5 7.034h-9.77v9.466h9.77v-9.466ZM8.98 20.25v-9.466H3.75v9.466h5.23Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default SvgLayout;
